import { render } from "./PriceView.vue?vue&type=template&id=13d50b3d&scoped=true"
import script from "./PriceView.vue?vue&type=script&lang=js"
export * from "./PriceView.vue?vue&type=script&lang=js"

import "./PriceView.vue?vue&type=style&index=0&id=13d50b3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d50b3d"]])

export default __exports__